<template>
  <div>
    <div class="page-wrapper">
      <div class="page-content-wrapper ml-0 px-3 pt-3">
        <h5 class="font-18">
          <a v-on:click="redirectTo()" class="mr-3"
            ><i class="bx bx-arrow-back cursor-pointer"></i
          ></a>
          {{ uuid ? "Edit" : "Add" }} User
        </h5>
        <div>
          <ul
            class="nav nav-pills col-12 row p-0 m-0"
            id="myTab"
            role="tablist"
            v-if="uuid">
            <li class="nav-item cursor-pointer col-6 p-0 m-0">
              <a
                class="nav-link"
                style="
                  text-align: center;
                  align-content: start;
                  background-color: white;
                  margin-top: 13px;
                  margin-bottom: 17px;
                  font-size: 14px;
                "
                data-toggle="tab"
                v-on:click="$router.push('/edit-user/' + this.uuid)">
                <span> Basic Information</span></a
              >
            </li>
            <li class="nav-item cursor-pointer col-6 p-0 m-0">
              <a
                class="nav-link active"
                data-toggle="tab"
                style="
                  text-align: center;
                  align-content: end;
                  background-color: white;
                  margin-top: 13px;
                  margin-bottom: 17px;
                  font-size: 14px;
                "
                :class="{ active: currentTab == 'SUBSCRIPTION_HISTORY' }"
                v-on:click="changeTab('SUBSCRIPTION_HISTORY')">
                <span>Subscription History</span></a
              >
            </li>
          </ul>

          <div class="page-content">
            <div class="card-body py-0 px-0">
              <div class="row">
                <div class="col-lg-6 col-sm-6 form-group">
                  <div class="d-flex">
                    <div class="has-search">
                      <i
                        class="fa fa-search"
                        style="position: absolute; margin: 10px"
                        aria-hidden="true"></i>
                      <input
                        type="text"
                        class="form-control"
                        v-on:keyup.enter="getList(0)"
                        placeholder="Search"
                        v-model="searchObj.keyword" />
                    </div>

                    <a
                      class="fill-btn btn-style cursor-pointer ml-3"
                      v-on:click="getList(0)"
                      >Search</a
                    >
                    <a
                      class="fill-btn btn-style cursor-pointer"
                      v-on:click="resetFilter"
                      v-show="searchObj.keyword"
                      >Reset</a
                    >
                  </div>
                </div>
                <div
                  style="cursor: pointer"
                  class="col-lg-6 col-sm-6 txt-right form-group">
                  <a
                    class="fill-btn cursor-pointer"
                    v-on:click="showAddPlanHistoryPopup()"
                    >+ Add</a
                  >
                </div>
              </div>
              <div class="card border mb-0 radius-15 mt-2">
                <div class="card-body p-0 pb-4">
                  <div class="table-responsive">
                    <div class="dataTables_wrapper dt-bootstrap4">
                      <table
                        class="table table-striped table-bordered dataTable"
                        style="width: 100%"
                        role="grid"
                        aria-describedby="example_info">
                        <thead>
                          <tr role="row">
                            <th>Sr. No.</th>
                            <th
                              class="sorting"
                              id="id-name"
                              v-on:click="sorting('name', 'id-name')">
                              Name
                            </th>
                            <th
                              class="sorting"
                              id="id-amount"
                              v-on:click="sorting('amount', 'id-amount')">
                              <div style="width: 60px">Price</div>
                            </th>
                            <th
                              class="sorting"
                              id="id-contact_view"
                              v-on:click="
                                sorting('contact_view', 'id-contact_view')
                              ">
                              <div style="width: 65px">Views</div>
                            </th>
                            <th
                              class="sorting"
                              id="id-validity"
                              v-on:click="sorting('validity', 'id-validity')">
                              <div style="width: 75px">Validity</div>
                            </th>
                            <th
                              class="sorting"
                              id="id-start_date"
                              v-on:click="
                                sorting('start_date', 'id-start_date')
                              ">
                              <div style="width: 100px">Start Date</div>
                            </th>
                            <th
                              class="sorting"
                              id="id-end_date"
                              v-on:click="sorting('end_date', 'id-end_date')">
                              <div style="width: 90px">End Date</div>
                            </th>
                            <th
                              class="sorting"
                              id="id-payment_date"
                              v-on:click="
                                sorting('payment_date', 'id-payment_date')
                              ">
                              <div style="width: 90px">Payment Date</div>
                            </th>
                            <th
                              class="sorting"
                              id="id-payment_mode"
                              v-on:click="
                                sorting('payment_mode', 'id-payment_mode')
                              ">
                              <div style="width: 135px">Payment Mode</div>
                            </th>
                            <th>Action</th>
                          </tr>
                        </thead>
                        <tbody v-show="!loader">
                          <tr v-for="(data, index) in list" :key="index">
                            <td style="text-align: left">
                              {{
                                ($refs.listPagination.currentPage - 1) * 10 +
                                index +
                                1
                              }}
                            </td>
                            <td style="text-align: left">
                              {{ data.name ? data.name : "-" }}
                            </td>
                            <td style="text-align: left">
                              {{ data.amount ? data.amount : "0" }}
                            </td>
                            <td style="text-align: left">
                              {{
                                data.max_contact_views_count
                                  ? data.max_contact_views_count
                                  : "-"
                              }}
                            </td>
                            <td style="text-align: left">
                              {{ data.validity ? data.validity : "-" }}
                            </td>
                            <td style="text-align: left">
                              {{
                                data.start_date
                                  ? $helperService.getFormatedDate(
                                      data.payment_date
                                    )
                                  : "-"
                              }}
                            </td>
                            <td style="text-align: left">
                              {{
                                data.end_date
                                  ? $helperService.getFormatedDate(
                                      data.end_date
                                    )
                                  : "-"
                              }}
                            </td>
                            <td style="text-align: left">
                              {{
                                data.payment_date
                                  ? $helperService.getFormatedDate(
                                      data.payment_date
                                    )
                                  : "-"
                              }}
                            </td>
                            <td style="text-align: left">
                              {{ data.payment_mode ? data.payment_mode : "-" }}
                            </td>
                            <td>
                              <a
                                class="fill-btn btn-style cursor-pointer"
                                v-on:click="showUpdatePlanHistoryPopup(data)"
                                >View</a
                              >
                              <a
                                class="fill-btn btn-style cursor-pointer"
                                v-on:click="showDeletePlanHistoryPopup(data)"
                                >DELETE</a
                              >
                              <!-- <a
                                v-if="data.status == 'ACTIVE'"
                                class="fill-btn btn-style cursor-pointer"
                                v-on:click="showDeactivatePopup(data)"
                                >Deactivate</a
                              >
                              <a
                                v-if="data.status == 'INACTIVE'"
                                class="fill-btn btn-style cursor-pointer"
                                v-on:click="showActivatePopup(data)"
                                >Activate</a
                              > -->
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                  </div>
                  <div class="row mx-0 mb-4">
                    <div class="col-lg-12 mt-5 text-center">
                      <div class="page-bottom-pagination text-right">
                        <Pagination
                          @page-change="pageChange"
                          @items-per-page-change="itemsPerPageChange"
                          ref="listPagination" />
                      </div>
                    </div>
                  </div>
                  <ErrorComponent @retry="getList(0)" ref="errorComponent" />
                </div>
              </div>
            </div>
          </div>
          <!-- <div class="text-center" style="margin-top: 20%">
            <h3>You do not have access to view subscription plan</h3>
          </div> -->
        </div>
      </div>
    </div>
    <DeleteModal @remove="deleteRecord($event)" ref="deleteModal" />
  </div>
  <TextModal ref="textModal">
    <div class="modal-header">
      <h5 class="modal-title" style="font-weight: bold">
        {{ this.detail.uuid ? "View" : "Add" }} Plan
      </h5>
      <button type="button" class="close" v-on:click="closeModal()">
        <span aria-hidden="true">&times;</span>
      </button>
    </div>
    <Form ref="planHistoryForm" @submit="save()">
      <div class="modal-body">
        <div class="row">
          <div class="col-lg-6 form-group">
            <label for="inputRole">Name</label>
            <span class="text-danger">*</span>
            <Field
              as="select"
              class="form-control"
              id="inputRole"
              name="subscription_plan"
              v-model="detail.plan_id"
              rules="required: plan, true"
              @change="planData($event)"
              :disabled="detail.type == 'VIEW'">
              <option value="" disabled>Select Plan</option>
              <option
                v-for="(data, index) in planList"
                :key="index"
                :value="data.uuid">
                {{ data.name }}
              </option>
            </Field>
            <ErrorMessage
              v-if="detail.type != 'VIEW'"
              name="subscription_plan"
              class="text-danger" />
          </div>
          <div class="col-lg-6 form-group">
            <label>Price</label>
            <span class="text-danger">*</span>
            <Field
              type="text"
              class="form-control"
              name="priced"
              placeholder="Price"
              rules="required:price"
              :validateOnInput="true"
              v-model="detail.amount"
              :disabled="detail.type == 'VIEW'" />
            <ErrorMessage
              v-if="detail.type != 'VIEW'"
              name="priced"
              class="text-danger" />
          </div>
          <div class="col-lg-6 form-group">
            <label>Payment Mode</label>
            <span class="text-danger">*</span>
            <Field
              as="select"
              class="form-control"
              id="inputRole"
              name="payment_mode"
              v-model="detail.payment_mode"
              rules="required:payment mode,true"
              :disabled="detail.type == 'VIEW'">
              <option value="" disabled>Select Payment Mode</option>
              <option value="CASH">Cash</option>
              <option value="ONLINE">Online</option>
              <option value="OTHER">Other</option>
            </Field>
            <ErrorMessage
              v-if="detail.type != 'VIEW'"
              name="payment_mode"
              class="text-danger" />
          </div>
          <div class="col-6 form-group">
            <label>Payment Date</label>
            <Datepicker
              v-model="detail.payment_date"
              inputFormat="dd-MM-yyyy"
              format="dd-MM-yyyy"
              placeholder="Payment Date"
              :clearable="false"
              :disabled="detail.type == 'VIEW'"
              style="background-color: white !important"
              :autoApply="true"
              :max-date="new Date()" />
          </div>

          <div class="col-lg-12 form-group" v-if="detail.type == 'ADD'">
            <label>Note</label>
            <!-- <span class="text-danger">*</span> -->
            <Field
              as="textarea"
              class="form-control"
              name="Note"
              placeholder="Note"
              rows="4"
              :validateOnInput="true"
              v-model="detail.description"
              style="height: 100px !important" />
            <!-- <ErrorMessage name="description" class="text-danger" /> -->
          </div>
          <div
            class="col-lg-12 form-group"
            v-if="detail.type == 'VIEW' && detail.description">
            <label>Description</label>
            <br />
            <div
              style="
                border: 1px solid #ced4da;
                padding: 5px;
                border-radius: 4px;
                height: 100px;
              ">
              <span v-html="detail.description"> </span>
            </div>
          </div>
        </div>
      </div>
      <div class="modal-footer">
        <button class="fill-btn" id="save-button" v-if="detail.type == 'ADD'">
          Save
        </button>
        <button
          type="button"
          class="fil-btn"
          id="cancel-button"
          v-if="detail.type == 'ADD'"
          v-on:click="$refs.textModal.closeModal">
          Cancel
        </button>
        <button
          v-if="detail.type == 'VIEW'"
          type="button"
          class="fil-btn"
          id="cancel-button"
          v-on:click="closeModal()">
          Back
        </button>
      </div>
    </Form>
  </TextModal>
  <DeleteModal @remove="activate($event)" ref="activateModal" />
  <DeleteModal @remove="deleteRecord($event)" ref="deactivateModal" />
  <DeleteModal @remove="deleteRecord2($event)" ref="delete2Modal" />
</template>
<script>
import ErrorComponent from "@/components/ErrorComponent";
import { Form, Field, ErrorMessage } from "vee-validate";
import DeleteModal from "@/components/DeleteModal";
import Pagination from "@/components/Pagination";
import TextModal from "@/components/TextModal";
import Datepicker from "@vuepic/vue-datepicker";
// import datepicker from "vue3-datepicker";

export default {
  name: "SubscriptionPlanHistory",
  components: {
    ErrorComponent,
    DeleteModal,
    Pagination,
    TextModal,
    Datepicker,
    // datepicker,
    Form,
    Field,
    ErrorMessage,
  },
  data() {
    return {
      // accessObject: this.$helperService.getAccessLevel(
      //   "Manage Subscription Plan"
      // ),
      uuid: this.$route.params.uuid,
      loader: true,
      currentTab: "",
      planList: [],
      // isShowAccessDeniedMessage: false,
      searchObj: {
        keyword: "",
      },
      detail: {
        plan_id: "",
        payment_mode: "",
        payment_date: new Date(),
        description: "",
        amount: "",
        fee: "",
        type: "",
        user_id: this.uuid,
      },
      offset: -1,
      list: [],
    };
  },
  mounted() {
    //   if (!this.accessObject) {
    //     this.isShowAccessDeniedMessage = true;
    //     this.$router.push("/access-denied");
    //     return;
    //   }
    console.log("dfsdf", this.uuid);
    this.$helperService.showMenu("false");
    this.getList(0);
    this.changeTab("SUBSCRIPTION_HISTORY");
    this.getPlanList();
  },
  methods: {
    redirectTo() {
      if (localStorage.getItem("tab_type") == "MARRIED") {
        this.$router.push("/married-list/HIDE");
      } else {
        this.$router.push("/member-list/HIDE");
      }
    },
    planData(e,type) {
      var uuid = type  ? e  : e.target.value;
      if (uuid) {
        for (var i in this.planList) {
          if (uuid == this.planList[i].uuid) {
            this.detail.amount = this.planList[i].fee;
            break;
          }
        }
      }
    },
    getPlanList() {
      this.$api
        .getAPI({
          _action: "/plan/list",
        })
        .then((res) => {
          this.planList = res.list;
        })
        .catch(() => {});
    },
    pageChange(offset) {
      this.getList(offset - 1);
    },
    itemsPerPageChange() {
      this.itemsPerPage = this.$refs.listPagination.itemsPerPage;
      this.getList(0);
    },
    getList(page, orderBy, sortBy) {
      this.$refs.errorComponent.updateListLoader(true);
      this.list = [];
      this.searchObj.offset = page;
      if (orderBy) {
        this.searchObj.order_by = orderBy;
      }
      if (sortBy) {
        this.searchObj.sort_by = sortBy;
      }
      if (this.uuid) {
        this.searchObj.user_id = this.uuid;
      }
      this.$api
        .getAPI({
          _action: "/user-plan/pagination/list",
          _body: this.searchObj,
        })
        .then((res) => {
          this.loader = false;
          this.list = res.list;
          this.offset = res.next_offset;
          if (page == 0) {
            if (this.$refs.listPagination) {
              if (res.count != null && res.count > 0) {
                this.$refs.listPagination.setTotalCount(res.count);
              } else {
                this.$refs.listPagination.setTotalCount(0);
              }
            }
          }
          if (this.$refs.errorComponent) {
            this.$refs.errorComponent.setData(
              res,
              "No Subscription Plan History Available"
            );
            this.$refs.errorComponent.updateListLoader(false);
          }
        })
        .catch(() => {
          this.loader = false;
          if (this.$refs.errorComponent) {
            this.$refs.errorComponent.setData(0, undefined, "");
            this.$refs.errorComponent.updateListLoader(false);
          }
        });
    },
    sorting(sortBy, id) {
      var obj = this.$helperService.sorting(sortBy, id);
      this.getList(0, obj.order_by, obj.sort_by);
    },
    resetFilter() {
      this.searchObj.keyword = "";
      this.getList(0);
    },
    showAddPlanHistoryPopup() {
      // this.detail = {};
      // this.detail.user_id = "";
      this.detail.type = "ADD";
      this.detail.uuid = "";
      this.detail.plan_id = "";
      // this.detail.payment_mode = "";
      this.payment_date = null;
      this.detail.fee = "";
      // this.detail.description = "";
      this.$refs.textModal.showModal();
      this.$refs.planHistoryForm.resetForm();
    },
    showUpdatePlanHistoryPopup(data) {
      this.detail.type = "VIEW";
      this.detail.uuid = data.uuid;
      if (this.detail.uuid) {
        this.getDetail();
      }
      this.$refs.textModal.showModal();
      if (this.detail.plan_id) {
        this.planData(this.detail.plan_id,'NRM');
      }
    },
    showDeletePlanHistoryPopup(data) {
      this.$refs.delete2Modal.showModal(
        "Delete Admin",
        "Are you sure you want to delete " + data.name,
        data
      );
    },
    closeModal() {
      this.detail = {};
      this.$refs.textModal.closeModal();
      this.$refs.planHistoryForm.resetForm();
    },
    getDetail() {
      var obj = {};
      obj.uuid = this.detail.uuid;
      this.$api
        .getAPI({
          _action: "/user-plan/detail",
          _body: obj,
        })
        .then((res) => {
          this.detail = res;
          this.detail.type = "VIEW";
          this.detail.payment_mode = res.payment_mode;
        })
        .catch(() => {});
    },
    save() {
      var obj = {};
      (obj.plan_id = this.detail.plan_id),
        (obj.payment_mode = this.detail.payment_mode),
        (obj.payment_date = this.detail.payment_date),
        (obj.description = this.detail.description),
        (obj.amount = this.detail.amount),
        (obj.type = this.detail.type),
        (obj.user_id = this.uuid);
      this.$api
        .postAPI({
          _action: "/add-plan",
          _body: obj,
          _buttonId: "save-button",
        })
        .then(() => {
          console.log("object", this.uuid);
          this.getList(0);
          this.$refs.textModal.closeModal();
        })
        .catch(() => {});
    },
    changeTab(tab) {
      this.currentTab = tab;
      if (tab == "SUBSCRIPTION_HISTORY") {
        this.$router.push("/subscription-plan-history/" + this.uuid);
      }
    },

    showActivatePopup(data) {
      this.$refs.activateModal.showModal(
        "Activate Subscription Plan",
        "Are you sure you want to activate " + data.name,
        data
      );
    },
    activate(dataObj) {
      var detail = new Proxy(dataObj, {});
      var obj = {};
      if (detail.uuid) {
        obj.uuid = detail.uuid;
        obj.status = "ACTIVE";
      }
      this.$api
        .putAPI({
          _action: "/plan/status-update",
          _body: obj,
        })

        .then((res) => {
          if (res) {
            this.$refs.activateModal.closeModal();
            this.$notify({
              type: "success",
              text: "Plan updated successfully",
            });
            this.getList(0);
          }
        })
        .catch(() => {
          this.$refs.deleteModal.removeLoader();
        });
    },
    showDeactivatePopup(data) {
      this.$refs.deactivateModal.showModal(
        "Deactivate Subscription plan",
        "Are you sure you want to deactivate " + data.name,
        data
      );
    },
    deleteRecord(dataObj) {
      var detail = new Proxy(dataObj, {});
      var obj = {};
      if (detail.uuid) {
        obj.uuid = detail.uuid;
        obj.status = "INACTIVE";
      }
      this.$api
        .putAPI({
          _action: "/plan/status-update",
          _body: obj,
        })
        .then((res) => {
          if (res) {
            this.$refs.deactivateModal.closeModal();
            this.getList(0);
            this.$notify({
              type: "success",
              text: "Plan deactivated successfully",
            });
          }
        })
        .catch(() => {
          this.$refs.deactivateModal.removeLoader();
        });
    },
    deleteRecord2(dataObj) {
      var detail = new Proxy(dataObj, {});
      var obj = {};
      if (detail.uuid) {
        obj.uuid = detail.uuid;
      }
      this.$api
        .putAPI({
          _action: "/delete-plan",
          _body: obj,
        })
        .then((res) => {
          if (res) {
            this.$refs.delete2Modal.closeModal();
            this.getList(0);
            this.$notify({
              type: "success",
              text: res.message,
            });
          }
        })
        .catch(() => {
          this.$refs.deactivateModal.removeLoader();
        });
    },
  },
};
</script>
<style>
.page-content {
  padding-left: 0;
  padding-right: 0;
}

.spx-modal .spx-modal-body {
  padding: 0;
}
</style>
